import { render, staticRenderFns } from "./DocAIFileUploadField.vue?vue&type=template&id=68e607e8&scoped=true&"
import script from "./DocAIFileUploadField.vue?vue&type=script&lang=js&"
export * from "./DocAIFileUploadField.vue?vue&type=script&lang=js&"
import style0 from "./DocAIFileUploadField.vue?vue&type=style&index=0&id=68e607e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e607e8",
  null
  
)

export default component.exports